const tabs = [
  { key: 'repository', label: 'Repository', count: 14 },
  { key: 'audit_folders', label: 'Audit folders', count: 4 },
  { key: 'evidence_requests', label: 'Evidence requests', count: 5 },
  { key: 'completeness', label: 'Completeness', count: null }
];

const repository_stats = [
  { label: 'Evidence items', value: '14', note: 'Central proof store', tone: 'neutral' },
  { label: 'Expired', value: '3', note: 'Renewal required', tone: 'danger' },
  { label: 'Expiring soon', value: '1', note: 'Within 60 days', tone: 'warning' },
  { label: 'Confidential', value: '2', note: 'Restricted access', tone: 'neutral' }
];

const repository_categories = [
  { label: 'All', count: 14, active: true },
  { label: 'Suppliers', count: 3 },
  { label: 'Policies', count: 2 },
  { label: 'Risks', count: 1 },
  { label: 'Controls', count: 1 },
  { label: 'Audits', count: 1 },
  { label: 'Incidents', count: 1 },
  { label: 'Contracts', count: 1 },
  { label: 'Finance', count: 1 },
  { label: 'Data privacy', count: 2 },
  { label: 'Employees', count: 1 }
];

const repository_rows = [
  { ref: 'EV-001', evidence: 'ABC Tech - Tax clearance certificate', meta: '#tax #SARS #supplier', type: 'Certificate', linked_to: 'ABC Tech +6', access: 'Internal', ver: 'v2', status: 'Expired', status_tone: 'danger' },
  { ref: 'EV-002', evidence: 'Platform support agreement - signed', meta: '#contract #signed #ABC Tech', type: 'Contract', linked_to: 'K-101 +3', access: 'Restricted', ver: 'v1', status: 'Valid', status_tone: 'success' },
  { ref: 'EV-003', evidence: 'BlueData - Data processing agreement', meta: '#POPIA #DPA #operator', type: 'Agreement', linked_to: 'Operator register +3', access: 'Confidential', ver: 'v1', status: 'Expired', status_tone: 'danger' },
  { ref: 'EV-004', evidence: 'POPIA & ethics training certificate - L. Nkosi', meta: '#training #POPIA #ethics', type: 'Certificate', linked_to: 'L. Nkosi +3', access: 'Internal', ver: 'v1', status: 'Valid', status_tone: 'success' },
  { ref: 'EV-005', evidence: 'Q1 privileged-access review report', meta: '#access review #IT security #recertification', type: 'Report', linked_to: 'C-322 +3', access: 'Restricted', ver: 'v1', status: 'Expired', status_tone: 'danger' },
  { ref: 'EV-006', evidence: 'RFQ-088 evaluation & award pack', meta: '#procurement #RFQ #3 quotes', type: 'Document pack', linked_to: 'C-118 +3', access: 'Internal', ver: 'v3', status: 'No expiry', status_tone: 'info' },
  { ref: 'EV-007', evidence: 'Board resolution register - FY26', meta: '#governance #board #resolutions', type: 'Register', linked_to: 'C-501 +2', access: 'Restricted', ver: 'v4', status: 'No expiry', status_tone: 'info' },
  { ref: 'EV-008', evidence: 'Cyber-insurance schedule', meta: '#insurance #cyber #supplier', type: 'Certificate', linked_to: 'Atlas Cloud Infrastructure +2', access: 'Internal', ver: 'v1', status: 'Expiring soon', status_tone: 'warning' },
  { ref: 'EV-009', evidence: 'Enterprise risk register - FY26 Q1', meta: '#risk register #residual #appetite', type: 'Register', linked_to: 'R-01 +2', access: 'Restricted', ver: 'v2', status: 'No expiry', status_tone: 'info' },
  { ref: 'EV-010', evidence: 'Internal audit report - SCM Q1', meta: '#internal audit #SCM #findings', type: 'Report', linked_to: 'IA-2026-002 +2', access: 'Restricted', ver: 'v1', status: 'No expiry', status_tone: 'info' },
  { ref: 'EV-011', evidence: 'Bank reconciliation - April 2026', meta: '#reconciliation #finance #month-end', type: 'Report', linked_to: 'April close +1', access: 'Internal', ver: 'v1', status: 'No expiry', status_tone: 'info' },
  { ref: 'EV-012', evidence: 'Incident closure report - INC-02', meta: '#incident #closure #root cause', type: 'Report', linked_to: 'INC-02 +2', access: 'Confidential', ver: 'v1', status: 'No expiry', status_tone: 'info' },
  { ref: 'EV-013', evidence: 'Procurement policy - approved v3', meta: '#policy #procurement #approved', type: 'Policy', linked_to: 'Procurement policy +1', access: 'Internal', ver: 'v3', status: 'Valid', status_tone: 'success' },
  { ref: 'EV-014', evidence: 'DSAR response log - Q1 2026', meta: '#POPIA #DSAR #data subject', type: 'Log', linked_to: 'DSAR tracker +1', access: 'Restricted', ver: 'v1', status: 'No expiry', status_tone: 'info' }
];

const audit_folder_cards = [
  {
    status: 'Assembling',
    status_tone: 'warning',
    title: 'AGSA 2026 regularity audit pack',
    subtitle: 'Master external-audit evidence file for the AGSA regularity audit.',
    progress: 64,
    progress_label: '4 of 6 documents',
    valid_label: '2 valid',
    owner: 'COMPLIANCE - A. MOKOENA',
    action: 'Pack'
  },
  {
    status: 'Complete',
    status_tone: 'success',
    title: 'SCM compliance file',
    subtitle: 'Procurement evidence - quotes, evaluations, awards, deviations.',
    progress: 82,
    progress_label: '2 of 4 documents',
    valid_label: '1 valid',
    owner: 'SCM - T. MBATHA',
    action: 'Pack'
  },
  {
    status: 'Gaps',
    status_tone: 'danger',
    title: 'POPIA evidence file',
    subtitle: 'Operator DPAs, training certificates and DSAR responses.',
    progress: 40,
    progress_label: '2 of 5 documents',
    valid_label: '1 valid',
    owner: 'INFORMATION OFFICER - P. NAIDOO',
    action: 'Pack'
  },
  {
    status: 'Gaps',
    status_tone: 'danger',
    title: 'ABC Tech - supplier due diligence',
    subtitle: 'Full evidence trail for a single high-risk supplier.',
    progress: 60,
    progress_label: '3 of 5 documents',
    valid_label: '2 valid',
    owner: 'PROCUREMENT - T. MBATHA',
    action: 'Pack'
  }
];

const evidence_request_stats = [
  { label: 'Open requests', value: '4', note: 'Awaiting evidence', tone: 'warning' },
  { label: 'Provided', value: '1', note: 'Awaiting verification', tone: 'neutral' },
  { label: 'Verified', value: '0', note: 'Accepted & filed', tone: 'neutral' },
  { label: 'Total RFIs', value: '5', note: 'This audit cycle', tone: 'neutral' }
];

const evidence_request_rows = [
  { ref: 'RFE-01', evidence: 'Signed DPA for BlueData Services', requested_by: 'Internal Audit', owner: 'Legal - S. Abrahams', due: '24 May 2026', status: 'In progress', status_tone: 'warning' },
  { ref: 'RFE-02', evidence: 'April privileged-access review report', requested_by: 'AGSA', owner: 'CISO - R. Govender', due: '22 May 2026', status: 'Requested', status_tone: 'neutral' },
  { ref: 'RFE-03', evidence: 'Fresh tax clearance - ABC Tech', requested_by: 'Finance', owner: 'Procurement - T. Mbatha', due: '24 May 2026', status: 'In progress', status_tone: 'warning' },
  { ref: 'RFE-04', evidence: 'FY26 conflict-of-interest declarations (SCM)', requested_by: 'Internal Audit', owner: 'HR - N. Dlamini', due: '31 May 2026', status: 'Requested', status_tone: 'neutral' },
  { ref: 'RFE-05', evidence: 'RFQ-088 award approval (signed)', requested_by: 'AGSA', owner: 'SCM - T. Mbatha', due: '18 May 2026', status: 'Provided', status_tone: 'success' }
];

const completeness_summary = {
  score: 73,
  valid_on_file: 11,
  required: 15,
  gaps: 4
};

const completeness_rows = [
  { domain: 'Suppliers', required: 3, on_file: 3, valid: 2, completion: 67, tone: 'warning' },
  { domain: 'Policies', required: 2, on_file: 2, valid: 2, completion: 100, tone: 'success' },
  { domain: 'Risks', required: 1, on_file: 1, valid: 1, completion: 100, tone: 'success' },
  { domain: 'Controls', required: 2, on_file: 1, valid: 0, completion: 0, tone: 'danger' },
  { domain: 'Audits', required: 1, on_file: 1, valid: 1, completion: 100, tone: 'success' },
  { domain: 'Incidents', required: 1, on_file: 1, valid: 1, completion: 100, tone: 'success' },
  { domain: 'Contracts', required: 1, on_file: 1, valid: 1, completion: 100, tone: 'success' },
  { domain: 'Finance', required: 1, on_file: 1, valid: 1, completion: 100, tone: 'success' },
  { domain: 'Data privacy', required: 2, on_file: 1, valid: 1, completion: 50, tone: 'warning' },
  { domain: 'Employees', required: 1, on_file: 1, valid: 1, completion: 100, tone: 'success' }
];

export default {
  name: 'ComplyonEvidenceVault',
  data: () => ({
    tabs,
    active_tab: 'repository',
    repository_stats,
    repository_categories,
    repository_rows,
    audit_folder_cards,
    evidence_request_stats,
    evidence_request_rows,
    completeness_summary,
    completeness_rows
  }),
  methods: {
    set_tab(tab_key) {
      this.active_tab = tab_key;
    },
    category_icon(label) {
      const map = {
        Suppliers: 'bi-truck',
        Policies: 'bi-folder2',
        Risks: 'bi-exclamation-triangle',
        Controls: 'bi-shield-check',
        Audits: 'bi-clipboard2-check',
        Incidents: 'bi-activity',
        Contracts: 'bi-link-45deg',
        Finance: 'bi-building',
        'Data privacy': 'bi-shield-lock',
        Employees: 'bi-people'
      };

      return Reflect.get(map, label) || 'bi-folder2';
    },
    badge_class(tone) {
      if (tone === 'success') {
        return 'vault-badge-success';
      }
      if (tone === 'warning') {
        return 'vault-badge-warning';
      }
      if (tone === 'danger') {
        return 'vault-badge-danger';
      }
      return 'vault-badge-neutral';
    },
    folder_status_class(tone) {
      if (tone === 'success') {
        return 'vault-folder-success';
      }
      if (tone === 'warning') {
        return 'vault-folder-warning';
      }
      return 'vault-folder-danger';
    },
    chip_class(active) {
      return active ? 'vault-chip-active' : '';
    },
    access_class(access) {
      if (access === 'Internal') {
        return 'vault-access-internal';
      }
      if (access === 'Restricted') {
        return 'vault-access-restricted';
      }
      if (access === 'Confidential') {
        return 'vault-access-confidential';
      }
      return 'vault-access-neutral';
    },
    completion_bar_style(value) {
      const safe_value = Math.max(0, Math.min(100, Number(value) || 0));
      const style = { width: `${safe_value}%` };
      return style;
    },
    ring_style(value) {
      const safe_value = Math.max(0, Math.min(100, Number(value) || 0));
      const style = {
        background: `conic-gradient(#c25609 0 ${safe_value}%, #e7edf4 ${safe_value}% 100%)`
      };

      return style;
    },
    ring_text_style(value) {
      const safe_value = Math.max(0, Math.min(100, Number(value) || 0));
      const ring_value  = {
        '--ring-value': `${safe_value}%`
      };

      return ring_value ;
    }
  }
};
